/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './assets/css/tailwind.scss';
import Notifications from 'notiwind';

import { version } from './../package.json';
import * as Sentry from '@sentry/vue';
import Axios from '@auth/vue-share/utility/axios';
import { useAuthStore } from '@/stores/auth';
const pinia = createPinia();
const app = createApp(App);

Sentry.init({
    app,
    dsn: 'https://51aba5c8870f26e8743581d5c80b130b@sentry.venus.bayern/8',
    release: version,
    integrations: [
        new Sentry.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router)
        })
    ],

    tracesSampleRate: 1.0
});

app.use(pinia).use(router).use(Notifications).mount('#venus__auth_dashboard');

const authStore = useAuthStore();

Axios.axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401 && error.response.data.error.includes('token_')) {
            if (!authStore.isRefreshing) {
                // get a new tokens
                authStore
                    .refresh()
                    .then(() => {
                        location.reload();
                    })
                    .catch(() => {
                        location.href = authStore.getLoginUrl;
                    });
            }
        }

        return Promise.reject(error);
    }
);

export function getOAuthUrl() {
    return process.env.NODE_ENV === 'development'
        ? 'http://localhost:2000'
        : (process.env.VUE_APP_OAUTH ?? window.VUE_APP_OAUTH ?? 'https://auth.venus.bayern');
}
